module.exports = __webpack_public_path__ + "img/lang-27.50af2eba.jpg";